import request from '@/utils/request'
export function bannerList(type) {
    return request({
        url: 'api/index/bannerList',
        method: 'get',
        params:{type}
    })
}
export function noticeList() {
    return request({
        url: 'api/index/noticeList',
        method: 'get'
    })
}

export function cateList(params) {
    return request({
        url: 'api/index/cateList',
        method: 'get',
        params
    })
}

export function goodsList(params) {
    return request({
        url: 'api/index/goodsList',
        method: 'get',
        params
    })
}

export function rankList() {
    return request({
        url: 'api/usercenter/rankList',
        method: 'get'
    })
}
// 商品
export function goodsDetail(id) {
    return request({
        url: 'api/goods/goodsDetail',
        method: 'get',
        params:{id}
    })
}


export function createOrder(data) {
    return request({
        url: 'api/goods/createOrder',
        method: 'post',
        data
    })
}
// 购物车
export function addCart(data) {
    return request({
        url: 'api/cart/addCart',
        method: 'post',
        data
    })
}
export function cartList() {
    return request({
        url: 'api/cart/cartList',
        method: 'get',
    })
}
export function deleteCart(ids) {
    return request({
        url: 'api/cart/deleteCart',
        method: 'post',
        data:{ids}
    })
}
// 分类下的商品
export function goodsCategoryList(params) {
    return request({
        url: 'api/goods/goodsCategoryList',
        method: 'get',
        params
    })
}

export function cartCreateOrder(data) {
    return request({
        url: 'api/cart/cartCreateOrder',
        method: 'post',
        data
    })
}
// 商品评价
export function goodsEvaluate(params) {
    return request({
        url: 'api/goods/goodsEvaluate',
        method: 'get',
        params
    })
}
export function evaluate(data) {
    return request({
        url: 'api/goods/evaluate',
        method: 'post',
        data
    })
}
export function trialOrderCount() {
    return request({
        url: 'api/goods/trialOrderCount',
        method: 'get',
    })
}